"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserProfileForm = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const backendImport_1 = require("@front/backendImport");
const component_1 = require("@front/components/form-parts/form/component");
const component_2 = require("@front/layouts/default-layout/component");
const component_3 = require("@front/components/site-menu/component");
const trans_1 = require("../../../../../common/translations/trans");
//@ts-ignore                
let rwsTemplate = T.html `<template>
    <div class="container-fluid">
        <div class="user-profile-page">
            <div class="row">
                <div class="col-lg-8 col-12 pb-lg-5">
                    <div class="mb-2">
                        <h1>${'user.profile.title'.t()}</h1>                       
                    </div>
                    <div class="card card-body mb-5">
                        <the-form :onSubmit="${(x, c) => x.sendForm.bind(x)}">
                            <div class="form-row">
                                <div class="form-group col-md-6">
                                    <part-input 
                                        required="true"
                                        class="form-part" 
                                        label="${'user.profile.name.label'.t()}" 
                                        :value="${x => x.form.name}"
                                        name="name" 
                                        placeholder="${'user.profile.name.placeholder'.t()}"
                                    ></part-input>
                                </div>
                                <div class="form-group col-md-6">
                                    <part-select 
                                        required="true"
                                        class="form-part" 
                                        label="${'user.form.language.label'.t()}" 
                                        :value="${x => x.form.language}"
                                        name="language"
                                        placeholder="${'user.form.language.placeholder'.t()}"
                                        :options="${x => x.languageOptions}"
                                    ></part-select>
                                </div>                            
                            </div>                       
                            <div class="form-group">
                                <label>${'user.profile.picture.label'.t()}</label>
                                <div class="profile-pic-container text-center">
                                    ${(0, fast_element_1.when)(x => x.hasProfilePic, (0, fast_element_1.html) `
                                        <div class="current-profile-pic">
                                            <img :src="${x => x.profilePicPreview}" alt="Profile Picture" class="profile-pic-preview">
                                            <button @click="${x => x.removeProfilePic()}" type="button" class="btn btn-sm btn-danger remove-pic-btn">
                                                ${'user.profile.picture.remove'.t()}
                                            </button>
                                        </div>
                                    `)}
                                    <part-file-upload 
                                        class="form-part"                     
                                        :value="${x => x.form.profile_pic}"
                                        name="profile_pic" 
                                        accept="image/*"
                                        placeholder="${'user.profile.picture.placeholder'.t()}"
                                    ></part-file-upload>
                                </div>
                            </div>
                            <hr class="my-4">
                            <h5>${'user.profile.changePassword.title'.t()}</h5>
                            <p class="text-muted">${'user.profile.changePassword.description'.t()}</p>
                            <div class="form-group">
                                <part-input 
                                    class="form-part"
                                    label="${'user.profile.password.new.label'.t()}"
                                    :value="${x => x.form.passwd}" 
                                    name="passwd" 
                                    type="password" 
                                    placeholder="${'user.profile.password.placeholder'.t()}"
                                ></part-input>
                            </div>
                            <div class="form-group">
                                <part-input 
                                    class="form-part"
                                    label="${'user.profile.password.repeat.label'.t()}"
                                    :value="${x => x.form.repeat_passwd}" 
                                    name="repeat_passwd" 
                                    type="password"
                                    placeholder="${'user.profile.password.repeat.placeholder'.t()}"
                                ></part-input>
                            </div>
                            <div class="d-flex justify-content-end pt-3">
                                <button @click="${(x, c) => x.sendSubmit(x, c)}" type="submit" class="btn btn-primary btn-lg" :disabled="${x => x.loading}">
                                    ${(0, fast_element_1.when)(x => x.loading, (0, fast_element_1.html) `
                                        <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                    `)}
                                    ${'user.profile.submit'.t()}
                                </button>
                            </div>
                        </the-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>`;
require("./styles/layout.scss");
const styles = T.css `.user-profile-page .profile-pic-container .current-profile-pic {
  position: relative;
  display: inline-block;
  margin-bottom: 1rem;
}
.user-profile-page .profile-pic-container .current-profile-pic .profile-pic-preview {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border-radius: 50%;
  border: 3px solid #dee2e6;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.user-profile-page .profile-pic-container .current-profile-pic .remove-pic-btn {
  position: absolute;
  top: -5px;
  right: -5px;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  font-size: 12px;
}
.user-profile-page .profile-pic-container .current-profile-pic .remove-pic-btn:hover {
  background-color: #dc3545;
  border-color: #dc3545;
}
.user-profile-page .top-right-button-container {
  position: absolute;
  right: 0;
  top: 0;
}
.user-profile-page .text-muted {
  font-size: 0.9rem;
  margin-bottom: 1rem;
}
.user-profile-page hr {
  border-color: #e9ecef;
  margin: 2rem 0;
}`;
const shadowOptions = { "mode": "open" };
let UserProfileForm = class UserProfileForm extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.profilePicPreview = '';
        this.languageOptions = [
            { label: 'lang.en', value: 'en' },
            { label: 'lang.de', value: 'de' },
            { label: 'lang.es', value: 'es' },
            { label: 'lang.it', value: 'it' },
            { label: 'lang.pl', value: 'pl' },
            { label: 'lang.zh', value: 'zh' }
        ];
        this.form = {
            name: '',
            passwd: '',
            repeat_passwd: '',
            profile_pic: null,
            language: (0, trans_1.getCurrentLanguage)()
        };
        this.sendSubmit = component_1.FormComponent.sendSubmitEvent;
    }
    async connectedCallback() {
        super.connectedCallback();
        // Load current user data from DefaultLayout
        if (component_2.DefaultLayout.USER) {
            this.form = {
                name: component_2.DefaultLayout.USER.name || '',
                profile_pic: component_2.DefaultLayout.USER.profile_pic || null,
                language: component_2.DefaultLayout.USER.language || (0, trans_1.getCurrentLanguage)()
            };
            // Set profile picture preview if exists
            if (component_2.DefaultLayout.USER.profile_pic && component_2.DefaultLayout.USER.profile_pic.filename) {
                this.profilePicPreview = `/uploads/${component_2.DefaultLayout.USER.profile_pic.filename}`;
            }
        }
        // Listen for form value changes
        component_1.FormComponent.listenForValuesChange.bind(this)('form');
        // Listen for file upload changes
        this.on('file-upload', (event) => {
            if (event.detail.name === 'profile_pic') {
                this.form.profile_pic = event.detail.file;
                this.profilePicPreview = event.detail.preview;
            }
        });
        this.on('file-part:clear', (event) => {
            console.log({ event });
            if (event.detail.index === 0) { // Assuming single file upload
                this.profilePicPreview = '';
            }
        });
    }
    async sendForm(event) {
        event.preventDefault();
        try {
            this.loading = true;
            // Create a copy of form data for sending
            const formData = { ...this.form };
            // Remove password fields if they're empty (user doesn't want to change password)
            if (!formData.passwd || formData.passwd.trim() === '') {
                delete formData.passwd;
                delete formData.repeat_passwd;
            }
            // Validate password match if password is being changed
            if (formData.passwd && formData.passwd !== formData.repeat_passwd) {
                this.notifyService.notify('user.profile.form.passwordMismatch'.t(), 'error');
                return;
            }
            const response = await this.apiService.back.put('user.profile.update', formData);
            if (!response.success) {
                console.error(response.error);
                this.notifyService.notify(response.error || 'user.profile.form.updateFailed'.t(), 'error');
            }
            else {
                this.notifyService.notify('user.profile.form.updateSuccess'.t(), 'info');
                // Update the user data in DefaultLayout
                if (response.data) {
                    component_2.DefaultLayout.setUser(response.data); // Ensure the static method is called
                    if (response.data.profile_pic && response.data.profile_pic.filename) {
                        this.profilePicPreview = `/uploads/${response.data.profile_pic.filename}`;
                    }
                }
                // Clear password fields after successful update
                this.form.passwd = '';
                this.form.repeat_passwd = '';
                // Navigate back to dashboard or wherever appropriate
                component_3.SiteMenu.goto.bind(this)('/dashboard');
            }
        }
        catch (e) {
            console.error(e);
            this.notifyService.notify('user.profile.form.updateFailed'.t(), 'error');
        }
        finally {
            this.loading = false;
        }
    }
    removeProfilePic() {
        this.form.profile_pic = null;
        this.profilePicPreview = '';
        const partFile = this.$('part-file-upload[name="profile_pic"]');
        partFile.clearFile();
    }
    get hasProfilePic() {
        return this.profilePicPreview && this.profilePicPreview.length > 0;
    }
};
exports.UserProfileForm = UserProfileForm;
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], UserProfileForm.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], UserProfileForm.prototype, "profilePicPreview", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], UserProfileForm.prototype, "languageOptions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_a = typeof backendImport_1.IUserPayload !== "undefined" && backendImport_1.IUserPayload) === "function" ? _a : Object)
], UserProfileForm.prototype, "form", void 0);
exports.UserProfileForm = UserProfileForm = __decorate([
    (0, client_1.RWSView)('user-profile-form', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], UserProfileForm);
UserProfileForm.defineComponent();
